import "../Login/Login.css";
import Header from "../../components/Layouts/Header";
import Layout from "../../components/Layouts/Layout";
import Footer from "../../components/Layouts/Footer";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { useState, useEffect } from "react";
import Instance from "../../Utils/Axios";
import { useNavigate } from "react-router-dom";
import { showToast } from "../../Utils/index";
import useFormValidation from "../../Hooks/useformValidation";
import { forgotSchema } from "../../Utils/validationSchema";
import PremiumLoader from "../../components/Loader/PremiumLoader";

export default function Forgot() {
  const [step, setStep] = useState("EMAIL");
  const [emailValue, setEmailValue] = useState("");
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [otpAttempts, setOtpAttempts] = useState(0);
  const [resendTimer, setResendTimer] = useState(0);
  const [resendDisabled, setResendDisabled] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successData, setSuccessData] = useState({ resTitle: "", resType: "" });
  const [resendLoading, setResendLoading] = useState(false);
  const RESEND_COOLDOWN_SECONDS = 30;
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue,
    trigger,
  } = useFormValidation(forgotSchema);

  useEffect(() => {
    const token = localStorage.getItem("tokenId");
    if (token) {
      showToast("You are already logged in!", "success", "success");
      setTimeout(() => {
        navigate("/customer/dashboard");
      }, 1500);
    }
  }, []);

  const handleSendOtp = async () => {
    const isValid = await trigger("email");
    if (!isValid) return;

    const email = getValues("email");
    setLoading(true);

    Instance.post("/user/forgotPassword", { email })
      .then((res) => {
        if (res.data.resCode === "200") {
          setEmailValue(email);
          setStep("OTP");
          startResendCooldownTimer();
          showToast(res.data.resMessage, "success", "success");
        } else {
          showToast(res.data.resMessage, "error", "error");
        }
      })
      .catch((error) => {
        if (!error.toasted) {
          const resMessage =
            error?.response?.data?.resMessage ||
            error?.response?.data?.message ||
            error?.message ||
            "Failed to send OTP";
          showToast(resMessage, "error", "error");
        }
      })
      .finally(() => setLoading(false));
  };

  const handleVerifyOtp = async () => {
    const isValid = await trigger("otp");
    if (!isValid) return;

    const email = getValues("email");
    const otp = getValues("otp");

    setLoading(true);

    Instance.post("/user/verifyEmailOTP", { email, otp })
      .then((res) => {
        if (res.data.resCode === "200") {
          showToast("OTP verified successfully!", "success", "success");
          setStep("PASSWORD");
        } else {
          showToast(res.data.resMessage, "error", "error");
        }
      })
      .catch((error) => {
        if (!error.toasted) {
          const resMessage =
            error?.response?.data?.resMessage ||
            error?.response?.data?.message ||
            error?.message;
          showToast(resMessage, "error", "error");
        }
      })
      .finally(() => setLoading(false));
  };

  const handlePasswordReset = (data) => {
    const payload = {
      email: getValues("email"),
      password: data.password,
      otp: data.otp,
    };
    setLoading(true);

    Instance.post("/user/resetPassword", payload)
      .then((res) => {
        if (res.data.resCode === "200") {
          setSuccessData({
            resTitle: res.data.resTitle || "Congratulation",
            resType:
              res.data.resType || "Your password has been reset successfully",
          });
          setShowSuccessModal(true);
        } else {
          showToast(res.data.resMessage, "error", "error");
        }
      })
      .catch((error) => {
        if (!error.toasted) {
          const resMessage =
            error?.response?.data?.resMessage ||
            error?.response?.data?.message ||
            error?.message;
          showToast(resMessage, "error", "error");
        }
      })
      .finally(() => setLoading(false));
  };

  const handleGoToLogin = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate("/");
    }, 200);
  };

  useEffect(() => {
    let interval;
    if (resendDisabled && resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setResendDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [resendDisabled, resendTimer]);

  const handleResendOtp = () => {
    if (resendDisabled || resendLoading || otpAttempts >= 5) {
      return;
    }

    const email = getValues("email");
    if (!email) return;

    setResendLoading(true);
    Instance.post("/user/forgotPassword", { email })
      .then((res) => {
        if (res.data.resCode === "200") {
          showToast("OTP resent successfully!", "success", "success");
          setOtpAttempts((prev) => prev + 1);
          startResendCooldownTimer();
        } else {
          showToast(res.data.resMessage, "error", "error");
        }
      })
      .catch((error) => {
        if (!error.toasted) {
          const resMessage =
            error?.response?.data?.resMessage ||
            error?.response?.data?.message ||
            error?.message;
          showToast(resMessage, "error", "error");
        }
      })
      .finally(() => setResendLoading(false));
  };

  const startResendCooldownTimer = () => {
    setResendDisabled(true);
    setResendTimer(RESEND_COOLDOWN_SECONDS);
  };

  return (
    <>
      {loading && <PremiumLoader text="Processing..." />}
      <div className="full_screen">
        <Header />
        <div className="content">
          <Layout>
            <div className="col-6 forgot_container">
              <Form onSubmit={step === "OTP" ? handleSubmit(handlePasswordReset) : (e) => e.preventDefault()}>
                <div className="forgot_wrapper">
                  <h1>Forgot Password</h1>

                  {/* Email Input */}
                  <div className="mb-3">
                    <div style={{ position: "relative" }}>
                      <Form.Control
                        type="email"
                        placeholder="Enter your registered email"
                        {...register("email")}
                        disabled={step !== "EMAIL"}
                        className={`form-control ${errors.email ? "is-invalid" : ""
                          }`}
                        style={{
                          paddingRight: step === "EMAIL" ? "100px" : "",
                        }}
                      />
                      {step === "EMAIL" && (
                        <span
                          className={`send-otp-text ${errors.email ? "is-invalid-text" : ""
                            }`}
                          onClick={() => !loading && handleSendOtp()}
                          style={{
                            position: "absolute",
                            right: "15px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: loading ? "not-allowed" : "pointer",
                            color: loading ? "#999" : "#6C63FF",
                            fontWeight: "600",
                            fontSize: "14px",
                            zIndex: 5,
                          }}
                        >
                          {loading ? "Sending..." : "Send OTP"}
                        </span>
                      )}
                    </div>
                    {errors.email && (
                      <div className="invalid-feedback d-block">
                        {errors.email.message}
                      </div>
                    )}
                  </div>

                  {/* OTP and Password Fields */}
                  {step === "OTP" && (
                    <>
                      <Form.Group className="mb-3">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <div style={{ flex: 1 }}></div>
                        </div>
                        <div className="position-relative">
                          <Form.Control
                            type="text"
                            placeholder="Confirm OTP"
                            {...register("otp")}
                            className={`form-control ${errors.otp ? "is-invalid" : ""
                              }`}
                            style={{ paddingRight: "100px" }}
                          />
                          <span
                            className="resend-otp-text"
                            onClick={() => !resendDisabled && !resendLoading && handleResendOtp()}
                            style={{
                              position: "absolute",
                              right: "15px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              cursor: (resendDisabled || resendLoading) ? "not-allowed" : "pointer",
                              color: (resendDisabled || resendLoading) ? "#999" : "#6C63FF",
                              fontWeight: "600",
                              fontSize: "14px",
                              zIndex: 5,
                            }}
                          >
                            {resendLoading ? "Sending..." : (resendDisabled ? `Resend in ${resendTimer}s` : "Resend OTP")}
                          </span>
                        </div>
                        {errors.otp && (
                          <div className="invalid-feedback d-block">
                            {errors.otp.message}
                          </div>
                        )}
                      </Form.Group>

                      <Form.Group className="password-wrapper mb-3">
                        <div className="input-icon-wrapper">
                          <Form.Control
                            type={visible ? "text" : "password"}
                            placeholder="Enter your new password"
                            {...register("password")}
                            isInvalid={!!errors.password}
                          />
                          <i
                            className={`bi ${visible ? "bi-eye" : "bi-eye-slash"} toggle-password-icon`}
                            onClick={() => setVisible(!visible)}
                            style={{ fontSize: "20px" }}
                          ></i>
                        </div>
                        <Form.Control.Feedback
                          type="invalid"
                          className="d-block feedback-message"
                        >
                          {errors.password?.message}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group className="password-wrapper mb-3">
                        <div className="input-icon-wrapper">
                          <Form.Control
                            type={visible2 ? "text" : "password"}
                            placeholder="Re-enter your password"
                            {...register("confirmPwd")}
                            isInvalid={!!errors.confirmPwd}
                          />
                          <i
                            className={`bi ${visible2 ? "bi-eye" : "bi-eye-slash"} ${errors.confirmPwd
                              ? "toggle-password-icon1"
                              : "toggle-password-icon"
                              }`}
                            onClick={() => setVisible2(!visible2)}
                            style={{ fontSize: "20px" }}
                          ></i>
                        </div>
                        <Form.Control.Feedback
                          type="invalid"
                          className="d-block feedback-message"
                        >
                          {errors.confirmPwd?.message}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <button
                        className="signin_btn w-100"
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? "Resetting..." : "Reset Password"}
                      </button>
                    </>
                  )}
                </div>
              </Form>

              <Modal
                show={showSuccessModal}
                onHide={() => navigate("/")}
                centered
                backdrop="static"
                keyboard={false}
              >
                <Modal.Body className="text-center p-4">
                  <div className="mb-2">
                    <i
                      className="bi bi-check-circle-fill"
                      style={{ fontSize: "50px", color: "#28a745" }}
                    ></i>
                  </div>
                  <h2
                    style={{
                      fontWeight: "700",
                      fontSize: "24px",
                      marginBottom: "8px",
                    }}
                  >
                    {successData.resTitle}
                  </h2>
                  <p
                    style={{
                      fontSize: "14px",
                      color: "#666666",
                      marginBottom: "16px",
                    }}
                  >
                    {successData.resType}
                  </p>
                  <button
                    className="signin_btn"
                    style={{
                      height: "40px",
                      fontSize: "14px",
                      marginTop: "0",
                      width: "150px",
                    }}
                    onClick={handleGoToLogin}
                  >
                    Go to Login
                  </button>
                </Modal.Body>
              </Modal>
            </div>
          </Layout>
        </div>
      </div>
    </>
  );
}
